<template>
  <div class="links">
    <div @click.exact="toggleOpenMenu(link.title)" v-for="(link, index) in links" :key="index" class="link" :class="{ 'link active active-line': $router.currentRoute.meta.parent === link.title || link.title === clickedRoute}" exact-active-class="active-line">
      <div class="title">
        <BaseIcon v-if="link.icon" :name="link.icon" size="2x" class="icon" />

        <span v-if="link.children" class="text">{{ link.title }}</span>
        <router-link v-else class="text" :to="'/' + link.name">{{ link.title }}</router-link>

        <BaseIcon v-if="link.children" name="chevron-down" class="icon" />
      </div>
      <NavigationSubLinks v-if="link.children" :link="link" class="pages" />
    </div>
  </div>
</template>

<script>
import NavigationSubLinks from "@/components/NavigationSubLinks";
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    NavigationSubLinks,
    BaseIcon
  },
  props: {
    links: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentRoute: String,
      clickedRoute: String,
    }
  },
  methods: {
    toggleOpenMenu(route){
      if(route === this.clickedRoute) {
        this.clickedRoute = ""
      } else {
        this.clickedRoute = route
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/nav";
@import "@/style/components/active";

</style>
